// Treatment step IDs in order
export const TREATMENT_STEP_ORDER = [
  'bookPreparatoryConsultation',
  'bookFirstTimeIntakeMedicationOne',
  'checkInMedicationOne',
  'bookFirstTimeIntakeMedicationTwo',
  'checkInMedicationTwo',
] as const;

// Type for step IDs
export type TreatmentStepId = typeof TREATMENT_STEP_ORDER[number];

// Individual step constants (optional, for easier reference)
export const TREATMENT_STEPS = {
  BOOK_PREPARATORY_CONSULTATION: 'bookPreparatoryConsultation',
  BOOK_FIRST_TIME_INTAKE_MEDICATION_ONE: 'bookFirstTimeIntakeMedicationOne',
  CHECK_IN_MEDICATION_ONE: 'checkInMedicationOne',
  BOOK_FIRST_TIME_INTAKE_MEDICATION_TWO: 'bookFirstTimeIntakeMedicationTwo',
  CHECK_IN_MEDICATION_TWO: 'checkInMedicationTwo',
} as const;
